import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import displayLoader from './display-loader';
import productList from './product-list';
import taxons from './taxons';
import order from './order';
import cartState from './cart-state';
import orderList from './order-list';
import countryList from './country-list';
import currentCheckoutStep from './current-checkout-step';
import placedOrder from './placed-order';
import user from './user';
import stores from './stores';
import locale from './locale';
import navigation from './navigation';
import error from './error';
import auth from './auth';
import zone from './zone';
import anonymousUser from './anonymous-user';
import backgroundDisabled from './background-disabled';
import fetchData from './fetch-data';
import configs from './configs';
import municipality from './municipality';
import wallets from './wallets';

const AppReducer = combineReducers({
    displayLoader,
    productList,
    taxons,
    order,
    cartState,
    orderList,
    countryList,
    currentCheckoutStep,
    placedOrder,
    user,
    auth,
    stores,
    locale,
    navigation,
    routing: routerReducer,
    form: formReducer,
    toastr: toastrReducer,
    error,
    zones: zone,
    municipalities: municipality,
    anonymousUser,
    backgroundDisabled,
    fetchData,
    configs,
    wallets,
});

export default AppReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/